// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1BvUY","balanceDisclaimer":"posDashboard_balanceDisclaimer__2r5tI"};